// Sometimes the lesson tries to perform two effects at once:
// (1) hide the keyboard, and (2) scroll down
// In this case, we need to hide the keyboard BEFORE scrolling,
// otherwise we get a jerky, not-smooth scroll.
// So, we define the keyboard delay to be 1ms shorter than the scroll delay.
export const LESSON_SCROLL_EFFECT_DELAY_MS = 50;
export const ENVELOPE_KEYBOARD_HIDE_DELAY_MS = LESSON_SCROLL_EFFECT_DELAY_MS - 1;
